module.exports = __webpack_public_path__ + "img/res2.577eecb6.png";